import React, {useEffect, useRef, useCallback, useState} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import ParticlesBg from "particles-bg";
import {Button, Form, Input, message} from "antd";
import {useNavigate} from "react-router-dom";
import { useStore } from "../../store"
import { loginApi } from "../../http/manager";
import { debounce } from "lodash";
// import Captcha from 'react-captcha-code';
// import type { canvasRefProps } from "react-captcha-code/build/types/captcha";

const Login: React.FC = () => {

    const navigateTo = useNavigate();
    const { loginStore } = useStore();
    const [ messageApi, contextHolder ] = message.useMessage();
    // const code = useRef<string>("");

    useEffect(() => {
        return loginStore.clearFormData;
    }, [loginStore.clearFormData]);

    const toManagerPage = () => {
        if (loginStore.loginName === undefined || !loginStore.loginName) {
            messageApi.open({
                type: "error",
                content: "请输入用户名",
            })
            return;
        }
        if (!loginStore.loginPassword) {
            messageApi.open({
                type: "error",
                content: "请输入密码",
            })
            return;
        }
        // if (!loginStore.loginCode) {
        //     message.error("请输入验证码")
        //     return;
        // }
        // if (loginStore.loginCode !== code.current) {
        //     message.error("验证码输入错误")
        //     return;
        // }
        loginDebounce();
    }

    const login = () => {
        const form = new FormData();
        form.set("useraccount", loginStore.loginName.toString());
        form.set("password", loginStore.loginPassword.toString());
        loginApi(form)
            .then((res: any) => {
                if (res && res.data) {
                    loginStore.setUserInfo(res.data.user);
                    localStorage.setItem('userInfo', JSON.stringify(res.data.user));
                    localStorage.setItem('menuList', JSON.stringify(res.data.user.menuList));
                    navigateTo("/manager/", {replace: true});
                } else {
                    message.error("获取用户信息失败");
                }
            })
    }

    const loginDebounce = debounce(login, 500)

    const onFormFinish = (changeValue: any, allValues: any) => {
        const {username, password, captchaCode} = changeValue;
        if (username) {
            loginStore.setName(username);
        }
        if (password) {
            loginStore.setLoginPassword(password);
        }
        // if (captchaCode) {
        //     loginStore.setLoginCode(captchaCode)
        // }
    }

    // const captchaRef = useRef<canvasRefProps | null>(null);

    // const handleChange = useCallback((captcha: any) => {
    //     code.current = captcha;
    //     console.log('captcha:', captcha);
    // }, []);

    return (
        <Wrapper>
            <ParticlesBg type={"cobweb"} bg={true} color={"#1677ff"}/>
            <LoginBgWrapper>
                <TitleSpan>湖北省药品监督检验研究院中药数字标本馆</TitleSpan>
                <Form
                    style={{width: "300px", alignSelf:"center"}}
                    layout={"vertical"}
                    name="basic"
                    onValuesChange={onFormFinish}
                    initialValues={{ remember: true }}
                    autoComplete="off">
                    <Form.Item
                        label="用户名"
                        name="username"
                        rules={[{ required: true, message: '请输入用户名!' }]}
                    >
                        <Input placeholder={"请输入用户名"} />
                    </Form.Item>

                    <Form.Item
                        label="密码"
                        name="password"
                        rules={[{ required: true, message: '请输入密码' }]}
                    >
                        <Input.Password visibilityToggle={false}  placeholder={"请输入密码"}/>
                    </Form.Item>

                    {/* <Form.Item
                        label="验证码"
                        name="captchaCode"
                        rules={[{ required: true, message: '请输入验证码' }]}
                    >
                        <div style={{display: "flex", justifyContent: "space-between", gap: "10px"}}>
                            <Input
                                placeholder={"请输入验证码"}
                            />
                            <Captcha ref={captchaRef} charNum={4} onChange={handleChange} />
                        </div>
                    </Form.Item> */}

                    <Form.Item>
                        <Button onClick={toManagerPage} size={"middle"} type="primary" htmlType="submit" style={{width: "300px"}}>
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            </LoginBgWrapper>
        </Wrapper>
    );
}
export default observer(Login);
const Wrapper = styled.div`
  & {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
const LoginBgWrapper = styled.div`
  &{
    align-self: center;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.3);
    color: #333333;
    padding: 30px;
  }
`;
const TitleSpan = styled.span`
  &{
    margin-left: 20px;
    font-size: 24px;
    line-height: 24px;
    font-weight: 500;
    flex: 1;
    text-align: left;
    z-index: 999;
    font-family: "Microsoft YaHei";
    font-style: italic;
    align-self: center;
    margin-bottom: 20px;
  }
`;